import { BlaestProduct } from "@/formatters/types";

export const getSpecs = (product: BlaestProduct) => {
  return {
    name: product.name,
    sku: product.sku,
    collection: product.collection,
    variant: product.variantName,
  };
};
